import { render, staticRenderFns } from "./organization-department-view.vue?vue&type=template&id=192e193a&"
import script from "./organization-department-view.vue?vue&type=script&lang=js&"
export * from "./organization-department-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports